export default __webpack_public_path__ + "media/app-store-qr.71a78.png";